import { Box, Typography, Grid } from '@mui/material'
import { COLORS } from '../constants/colors'
import { TEXT } from '../constants/text'
import { TIERS } from '../constants/tiers'
import TierGate from '../components/layout/TierGate'
import WhaleAlert from '../components/signals/WhaleAlert'
// Note: paths are correct — pages/ and components/ are siblings under frontend-v2/

// Demo whale data
const DEMO_WHALES = [
  { wallet: '7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU', symbol: 'BONK', amount: 4250, action: 'buy', timestamp: Date.now() },
  { wallet: '3nMFwZXwY1s1M5s8vYAHqd4wMNKnmvq6x8MN4BUvQHxo', symbol: 'WIF', amount: 1800, action: 'buy', timestamp: Date.now() - 60000 },
  { wallet: '9noXzpXnkyEcKF3AeXqUHTFR4gMaY9eFGdRm2JRbTAMn', symbol: 'POPCAT', amount: 3100, action: 'sell', timestamp: Date.now() - 120000 },
  { wallet: 'Hf4HLsQ2KCcR7CXfW9YJoh7bMCqkGnFPMaGMpFcHivVN', symbol: 'MYRO', amount: 5700, action: 'buy', timestamp: Date.now() - 180000 },
  { wallet: 'DhVpnYCexNaAYWWV33dLaJWJx3Ut5uNdNiB5DVJPGQQE', symbol: 'BOME', amount: 2300, action: 'buy', timestamp: Date.now() - 240000 },
]

export default function WhalesPage({ onUpgrade }) {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
        {TEXT.NAV.WHALES}
      </Typography>
      <Typography sx={{ color: COLORS.text.secondary, fontSize: '0.85rem', mb: 3 }}>
        Real-time tracking of Top 100 Solana wallets. See what smart money is buying.
      </Typography>

      <TierGate requiredTier={TIERS.PRO} onUpgrade={onUpgrade}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {DEMO_WHALES.map((w, i) => (
            <WhaleAlert key={i} {...w} />
          ))}
        </Box>
      </TierGate>
    </Box>
  )
}
